/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import React, { useState, useContext, useEffect } from 'react';
import { Badge, Collapse } from 'reactstrap';
import Alert from 'react-s-alert';

// context imports
import { ThemeContext } from '../../contexts/ThemeContext';

// service imports
import GeneralService from '../../services/GeneralService';

// local imports
import Session from './Session';

const RescheduleRequestedSession = props => {

    // context
    const { theme, colors } = useContext(ThemeContext);

    // states
    const [isRescheduleRequestedOpen, setIsRescheduleRequestedOpen] = useState(true);
    const [sessionList, setSessionList] = useState([]);
    const [newRescheduleRequest, setNewRescheduleRequest] = useState([]);

    // utility functions
    const toggleRescheduleRequested = () => setIsRescheduleRequestedOpen(!isRescheduleRequestedOpen);

    // useEffect
    useEffect(() => {
        try {
            if (props.sessions) {
                setSessionList(props.sessions);
            }
            if (props.newRescheduleRequest) {
                setNewRescheduleRequest(props.newRescheduleRequest);
            }
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at User RescheduleRequestedSession useEffect', 'Error in try catch block', err.stack);
        }
    }, [props.sessions])

    // function's return
    return (
        <div className="p-3 mt-3" style={theme.card} id="rescheduledSessions">
            <div className="row px-3" onClick={toggleRescheduleRequested} style={{ cursor: "pointer" }}>
                <span id="rescheduledRequests" style={theme.headingBold}>Reschedule Requested <Badge style={{ backgroundColor: colors.primary }}>{sessionList.length}</Badge> </span>

                {
                    sessionList.length ?
                        isRescheduleRequestedOpen
                            ? <span className="ml-auto" style={theme.headingRegular}><i className="fas fa-angle-up"></i>{newRescheduleRequest.length > 0 ? <Badge className="ml-1" style={{ backgroundColor: colors.warning }}>{newRescheduleRequest.length}</Badge> : null}</span>
                            : <span className="ml-auto" style={theme.headingRegular}><i className="fas fa-angle-down"></i>{newRescheduleRequest.length > 0 ? <Badge className="ml-1" style={{ backgroundColor: colors.warning }}>{newRescheduleRequest.length}</Badge> : null}</span>
                        : null
                }

            </div>

            <Collapse isOpen={sessionList.length ? isRescheduleRequestedOpen : false}>
                <hr />
                {
                    sessionList.map((item, index) => (
                        <Session key={index} selectedTimeZone={props.selectedTimeZone} handleModal={props.handleModal} detail={item} type="Recheduled" index={index} history={props.history} newRescheduleRequest={newRescheduleRequest} />
                    ))
                }
            </Collapse>


        </div>
    )
}

export default RescheduleRequestedSession;